import { isFullySelected } from './isFullySelected';
import type { DropdownValue, FlatItem } from '../../types';

/**
 * Labels of the highest fully selected nodes, in tree order.
 * A fully selected node hides its descendants; a partially selected node is
 * skipped so its selected descendants are listed instead. A value node counts
 * as fully selected only when it is selected itself (matching its checkbox), a
 * group when every selectable descendant is.
 */
export function getTopmostSelectedLabels({
  allItems,
  descendantsByValue,
  labelByValue,
  selectedSet,
}: {
  allItems: FlatItem[];
  descendantsByValue: Map<DropdownValue, DropdownValue[]>;
  labelByValue: Map<DropdownValue, string>;
  selectedSet: Set<DropdownValue>;
}): string[] {
  const labels: string[] = [];
  let skipDeeperThan: number | null = null;

  for (const item of allItems) {
    if (skipDeeperThan !== null && item.depth > skipDeeperThan) {
      continue;
    }

    skipDeeperThan = null;

    if (!isFullySelected(item, descendantsByValue, selectedSet)) {
      continue;
    }

    skipDeeperThan = item.depth;

    const label = labelByValue.get(item.value);

    if (label !== undefined) {
      labels.push(label);
    }
  }

  return labels;
}
